import BossModel from "@/models/BossModel";
import Task from "@/models/Task/Task";

export default class Schedule extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'task/schedule';

    /**
     *
     * @type {string}
     */
    static entity = 'taskSchedules';

    /**
     * Relations used for normalization
     * @returns {{}}
     */
    static fields() {
        return {
            id: this.attr(null),
            task_id: this.number(null).nullable(),
            scheduled_at: this.attr(null),
            created_at: this.number(null).nullable(),
            task: this.belongsTo(Task, 'task_id'),
        }
    }

    /**
     *
     * @param dossierId
     * @returns {*}
     */
    static loadByDossier(dossierId){
        return this.api()
            .where('dossier_id', dossierId)
            .limit(0)
            .with(['task', 'task.messages'])
            .get();
    }
}
